module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-field form-field__input form-field__select",
    class: [_vm.rootClasses]
  }, [(_vm.label) ? _c('label', {
    staticClass: "form-field--title-label",
    attrs: {
      "for": _vm.id
    },
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-field--input-container",
    attrs: {
      "data-action-count": _vm.actionCount + 1
    }
  }, [(_vm.isMounted) ? _c('select', _vm._b({
    ref: "input",
    staticClass: "form-field--input",
    on: {
      "change": function($event) {
        _vm.updateValue($event.target.value)
      },
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  }, 'select', _vm.inputBindings, false), [(_vm.placeholder) ? _c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    },
    domProps: {
      "selected": !_vm.value,
      "innerHTML": _vm._s(_vm.placeholder)
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.uniqueItems), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.val,
        "innerHTML": _vm._s(item.label || item.val)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-field--actions"
  }, [_c('span', {
    staticClass: "form-field--action form-field--action__arrow"
  }, [_c('cmp-icon', {
    attrs: {
      "symbol": "chevron_down",
      "size": "x-small"
    }
  })], 1)])]), _vm._v(" "), _c('cmp-form-field-messages-partial', {
    attrs: {
      "messages": _vm.messages,
      "active-item": _vm.activeItem
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b025327c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b025327c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/form/form-field-select/index.vue
// module id = 581
// module chunks = 7